import { takeEvery, call, put } from 'redux-saga/effects';
import { sendRequest, updateData, requestFinished } from '../reducer';
import { timeoutCall } from '../../../../../../../utils/sagaHalper';
import DataService from '../../../../../services/DataService';

function* getReferenceLists() {
  try {
    const response = yield call(timeoutCall, DataService.getReferenceListsNew);
    if (response) {
      if (response.status === 200) {
        yield put(updateData(response.data));
        // Для возможности брать справочник переводов в самом redux (в этом окружении некоторые формы хранятся в стейте)
        window.back_translations = response.data.translations.items;
      }
      yield put(requestFinished(response.status, response.status === 200));
    }
  } catch (error) {
    yield put(requestFinished());
  }
}

export default function createSaga() {
  return [takeEvery(sendRequest().type, getReferenceLists)];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/main/reducers/static/states/referenceLists/sagas/referenceListsSaga.js